import { render, staticRenderFns } from "./RingLoader.vue?vue&type=template&id=af1067ec&scoped=true"
import script from "./RingLoader.vue?vue&type=script&lang=js"
export * from "./RingLoader.vue?vue&type=script&lang=js"
import style0 from "./RingLoader.vue?vue&type=style&index=0&id=af1067ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1067ec",
  null
  
)

export default component.exports